<template>
<main class="main-wrapper flex-grow-1">
	<div class="d-flex align-items-center bg-white mgl-12 mgr-12">
		<button @click="$router.go(-1)" class="material-icons  mdc-icon-button t-color-headlineBlack rtl-support">
      <div class="mdc-button__ripple"></div>
      arrow_back
    </button>
		<div class="mgr-48 t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
			{{$t('120')}}
		</div>
		<div class="mgr-24 right-button">
			<button class="mdc-icon-button" tabindex="0" @click="bookMark">
				<i :class="unClipping ? 't-color-contentVariationInactive' : 't-color-contentBlue'" class="material-icons ">bookmark</i>
			</button>
		</div>
	</div>
	<div class="divider"></div>
	<div class="subtabs ">
		<div id="missionViewTab" class="mdc-tab-bar main-tabs" role="tablist">
			<div class="mdc-tab-scroller ">
				<div class="mdc-tab-scroller__scroll-area">
					<div class="mdc-tab-scroller__scroll-content justify-content-center">
						<button class="mdc-tab mdc-tab--active" role="tab" tabindex="0" @click="setTab('myAssignment')">
							<span class="mdc-tab__content">
								<span class="mdc-tab__text-label font-m t-body2">{{ $t("3471") }}</span>
							</span>
							<span class="mdc-tab-indicator mdc-tab-indicator--active">
								<span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
							</span>
							<span class="mdc-tab__ripple"></span>
						</button>
						<button class="mdc-tab " role="tab" tabindex="0" @click="setTab('missionInfo')">
								<span class="mdc-tab__content">
									<span class="mdc-tab__text-label font-m t-body2">{{ $t("3472") }}</span>
								</span>
								<span class="mdc-tab-indicator ">
									<span	class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
								</span>
								<span class="mdc-tab__ripple"></span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="divider divider-subtabs"></div>
	</div>
        <view-myAssignment
              v-if="missionData && tabType === 'myAssignment'"
              :answer="missionData.answer"
              :answerText="answerText"
              :description="missionData.description"
              :eval="missionData.eval"
              :name="missionData.name"
              :reference="missionData.reference"
              :status="missionData.status"
              :submissionDateEnd="missionData.submissionDate.end"
              :submissionDateStart="missionData.submissionDate.start"
        ></view-myAssignment>
		<view-information
              v-if="missionData && tabType === 'missionInfo'"
              :answer="missionData.answer"
              :description="missionData.description"
              :eval="missionData.eval"
              :name="missionData.name"
              :reference="missionData.reference"
              :status="missionData.status"
              :submissionDateEnd="missionData.submissionDate.end"
              :submissionDateStart="missionData.submissionDate.start"
        ></view-information>
</main>

</template>

<script>
/**
 * 나의 학습 상세 - 미션 상세 메인 컴포넌트(my learning view - mission view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import microLearnApi from "@/api/microLearnApi";
import Information from './Information.vue';
import Feedback from './Feedback.vue';
import myAssignment from "./MyAssignment.vue";

import { topAppBarMixin } from '@/mixins/topAppBar.js';

import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar';

export default {
	data() {
		return {
      answer: null,
      answerText: null,
			missionData: null,
			tabBar: null,
			tabType: 'myAssignment',
			unClipping:true,
			clippingBookMark: false,
			clippingCount: 0,
			showSubmit: false
		}
	},

	components: {
		'view-information': Information,
		'view-feedback': Feedback,
    "view-myAssignment": myAssignment,
	},

	mixins: [topAppBarMixin],

	mounted() {
		this.fatchData();
		this.tabBar = new MDCTabBar(document.querySelector('#missionViewTab'))
        if(localStorage.getItem('Information')) {
            this.tabType = 'missionInfo';
            this.tabBar.activateTab(1);
            localStorage.removeItem('Information');
        }
	},

  beforeMount(){
    if(this.$route.name === 'MicroMissionUpdate' || this.$route.name ===  'MicroMissionViewSubmit'){
      this.showSubmit = true;
    }
  },

	methods: {
		// 미션 상세 정보 API 호출(get mission view data)
		fatchData() {
			let params = {
				learnId: this.$route.params.learnId,
				assignmentId: this.$route.params.assignmentId
			}
			microLearnApi.learnViewMissionView(params).then((response) => {
				this.missionData = response.data.data;
        this.answerText = this.missionData.answer.text;

				if(this.missionData.clipping === true) {
					this.clippingBookMark =  true;
					this.unClipping = false;
				}
			});
		},

		setTab(type) {
			this.tabType = type;
		},

		bookMark() {
			let params = {
				learnId: this.$route.params.learnId,
				assignmentId: this.$route.params.assignmentId
			}
			if(this.clippingBookMark === false) {
        microLearnApi.learnMissionClippingPost(params).then((response) => {
					if(response.data.data === true) {
						this.clippingBookMark =  true
						this.unClipping = false
					} else {
						this.unClipping = true
					}
				}).catch((err) => {
				})
			}
			if(this.clippingBookMark === true) {
				microLearnApi.learnMissionClippingDelete(params).then((response) => {
					if(response.data.data === true){
						this.clippingBookMark = false
						this.unClipping = true
					} else {
						this.unClipping = true
					}
				}).catch((err) => {

				})
			}
		}
	}
}
</script>
